import {
  type ISavedEmailSection,
  savedEmailSectionSchema,
} from "@redotech/redo-model/saved-email-section";
import * as z from "zod";

export const getSavedEmailSectionById = {
  name: "getSavedEmailSectionById" as const,
  input: z.object({
    sectionId: z.string(),
    includeArchived: z.boolean().optional(),
  }),
  output: (savedEmailSectionSchema as ISavedEmailSection).nullable(),
};
